export default "__VITE_ASSET__CuquJFci__"